export const environment = {
  NODE_ENV: null,
  GA_ID: null,
  FIREBASE_CONFIG: null,
  production: false,
  configFile: 'assets/config/config.dev.json',
  baseUrl: 'http://localhost:4200/#/registration?city='
};
